var _defs, _g, _rect;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCheckFail(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a,.b{fill:none;}.a{stroke:#ef5b5b;stroke-linecap:round;stroke-linejoin:round;stroke-width:4px;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(2 2)"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "a",
    cx: 26,
    cy: 26,
    r: 26
  }), /*#__PURE__*/React.createElement("line", {
    className: "a",
    x1: 14,
    y2: 14,
    transform: "translate(19 19)"
  }), /*#__PURE__*/React.createElement("line", {
    className: "a",
    x2: 14,
    y2: 14,
    transform: "translate(19 19)"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "b",
    width: 56,
    height: 56
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckFail);
export default __webpack_public_path__ + "static/media/check-fail.b8d679b9040a2eada21448f5a6b22f40.svg";
export { ForwardRef as ReactComponent };